// extracted by mini-css-extract-plugin
module.exports = {"fullscreenModalLockHeader":"fullscreen-modal-lock_fullscreenModalLockHeader__rJYKE"};